<template>
    <div class="container">
        <b-modal
            :model-value="modalEditar"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <!-- <pre>{{ infoEdit }}</pre> -->
                 <!-- <pre>{{ infoCaract }}</pre> -->
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.codigo }}</label>
                        <p>{{ form.tipo_activo }}</p>
                        <label>{{ labels.descripcion }}</label>
                        <b-form-input
                            v-model="form.descripcion"
                            type="text"
                            class="reset-input"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-row class="text-center">
                    <b-col cols="12 mt-4">
                        <h5>{{ labels.caracteristica }}</h5> 
                    </b-col>
                </b-row>
                <div>
                    <!-- Características existentes -->
                    <b-row
                        class="mt-2"
                        v-for="caracteristica in infoCaract"
                        :key="'old'+caracteristica.id"
                    >
                        <b-col cols="2"></b-col>

                        <b-col cols="4">
                            <h5>{{ caracteristica.caracteristica }}</h5>
                        </b-col>

                        <b-col cols="6">
                            <b-form-input
                                v-model="caracteristica.descripcion"
                            />
                        </b-col>
                    </b-row>

                    <!-- Nuevas características -->
                    <b-row
                        class="mt-2"
                        v-for="(item,index) in nuevasCaracteristicas"
                        :key="'new'+index"
                    >
                        <b-col cols="2"></b-col>

                        <b-col cols="4">
                            <b-form-input
                                v-model="item.codigo"
                                placeholder="Código"
                            />
                        </b-col>

                        <b-col cols="6">
                            <b-form-input
                                v-model="item.descripcion"
                                placeholder="Descripción"
                            />
                        </b-col>
                    </b-row>

                </div>
                <b-row class="d-flex justify-content-center mt-3">
                    <b-button style="background-color: #2e507a; width: 30px; height: 30px;" class="md-fab md-primary" @click="addCaracteristica()">
                        <i class="fa-solid fa-plus"></i>
                    </b-button>
                </b-row>
                <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                    <b-button
                        class="reset-btn-delete me-auto"
                        @click="eliminaRegistro()"
                    >
                        {{ labels.delete }}
                    </b-button>
                    <b-button
                        class="mr-2 reset-btn-secondary"
                        @click="cierraModal()"
                    >
                        {{ labels.close }}
                    </b-button>
                    <b-button
                        class="reset-btn-primary"
                        @click="guardarTipoActivo()"
                    >
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>
        <InacticaItem :InactivaItem="delTipoActivo" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"/>
    </div>
</template>

<script>
import TipoActivo from '../../../services/TipoActivo' 
import TipoActivoCaracteristica from '../../../services/TipoActivoCaracteristica'; 
import InacticaItem from '../../utils/InacticaItem.vue'

export default {
    name:'Editar',
    props: {
        modalEditar: {
            type: Boolean,
            default: false
        },
        infoEdit: {
            type: Array,
            default: () => []
        },
        infoCaract: {
            type: Array,
            default: () => []
        }
    },
    components: {InacticaItem},
    data() {
        return {
            form: {
                id: null,
                tipo_activo: "",
                descripcion: ""
            },
            nuevasCaracteristicas: [],
            cont: 0,
            delTipoActivo : false,
            idTipoActivo : null
        }
    },
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Editar tipo activo",
                    codigo : "Código",
                    descripcion : "Descripción",
                    caracteristica: "Caracteristicas",
                    save : "Guardar",
                    close : "Cerrar",
                    delete : 'Eliminar',
                    formInfoTitle: "Datos del tipo de activo",
                    formInfoSubtitle: "Actualiza la información del tipo de activo y guarda los cambios."
                }
            }else{
                return {
                    title: "Edit active type",
                    codigo : "Code",
                    descripcion : "Description",
                    caracteristica: "Characteristics",
                    save : "Sava",
                    close : "Close",
                    delete : 'Delete',
                    formInfoTitle: "Asset type data",
                    formInfoSubtitle: "Update the asset type information and save the changes."
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.cleannInp();
            this.$emit('cierraModal',false) 
        },
        async guardarTipoActivo() {

            try {

                if (!this.form.descripcion.trim()) {
                    return this.$toast.error("Campo(s) pendiente(s) por diligenciar");
                }

                // Validar nuevas características
                if (this.nuevasCaracteristicas.length > 0) {

                    for (const item of this.nuevasCaracteristicas) {

                        if (!item.codigo || !item.descripcion.trim()) {

                            return this.$toast.error(
                                "Debe diligenciar todas las características."
                            );

                        }

                    }
                }

                const listCaracteristicas = [];

                this.nuevasCaracteristicas.forEach(item => {

                    listCaracteristicas.push({

                        codTipoActivo: Number(this.form.tipo_activo),
                        codCaracteristica: Number(item.codigo),
                        caracteristica: item.descripcion,
                        idUser: this.$store.state.userId

                    });

                });

                // Actualizar tipo activo
                const info = {
                    idTipoActivo: this.form.id,
                    descripcion: this.form.descripcion,
                    idUser: this.$store.state.userId
                };

                const resTipo = await TipoActivo.updateActivoById(info);

                // Actualizar características existentes
                if (this.infoCaract.length > 0) {

                    await TipoActivoCaracteristica.updateTipoActivoCaractById(
                        this.infoCaract
                    );

                }

                // Crear nuevas características
                if (listCaracteristicas.length > 0) {

                    await TipoActivoCaracteristica.createTipoActivoCaract(
                        listCaracteristicas
                    );

                }

                this.$toast.success(resTipo.data.message == undefined ? 'Caracteristicas actualizadas.' : resTipo.data.message);
                this.$emit("actualizado");
                this.cierraModal();

            } catch (error) {

                if (error.response) {

                    this.$toast.error(error.response.data.message);

                } else {

                    console.error(error);

                    this.$toast.error(
                        "Ocurrió un error al actualizar el tipo de activo."
                    );

                }

            }

        },
        /*guardarTipoActivo(){

            if (!this.form.descripcion.trim()) {
                return this.$toast.error("Campo(s) pendiente(s) por diligenciar");
            }

            if(this.cont >= 1){
                //////////////////GUARDA NUEVA CARACTERISTICA//////////////////

                if(document.getElementById('caracteristica'+0).value == ''){ 
                    this.$toast.error('Debe agregar la caracteristica.') 
                    location. reload() 
                    return
                }

                this.cantFilaCaract.forEach((e,ind) => { 
                    console.log(e); 

                    if(document.getElementById('caracteristica'+ind).value == ''){ 
                        return this.$toast?.error('Debe agregar la caracteristica?.') 
                    }

                    this.listCaracteristicas.push({
                        codTipoActivo: Number(this.form.tipo_activo),
                        codCaracteristica: Number(document.getElementById(`caracteristica${ind}`).value),
                        caracteristica: document.getElementById(`valor${ind}`).value,
                        idUser: this.$store.state.userId
                    });
                })
                // console.log(listCaracteristicas); 

                TipoActivoCaracteristica.createTipoActivoCaract(this.listCaracteristicas) 
                .then((res) => { 
                    if(res.status == 201){ 
                        this.$toast.success(res.data.message) 
                        location. reload() 
                    
                    }else if(res.status == 204){ 
                        this.$toast.error('Caracteristica ingresada ya existe.') 
                        return
                    }
                })
                .catch((error) => error) 
                //////////////////FIN GUARDA NUEVA CARACTERISTICA//////////////////
            
            }else{

                TipoActivoCaracteristica.updateTipoActivoCaractById(this.infoCaract) 
                .then((res) => { 
                    if(res.status == 200){ 
                        this.$toast.success(res.data.message) 
                        location. reload() 
                    
                    }else if(res.status == 404){ 
                        this.$toast.error('Caracteristica no encontrada.') 
                        return
                    }
                })
                .catch((error) => error) 
            }

            let info = {
                'idTipoActivo' : this.form.id, 
                'descripcion' : this.form.descripcion, 
                'idUser' : this.$store.state.userId 
            }

            TipoActivo.updateActivoById(info) 
            .then((res) => { 
                if(res.status == 200){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("actualizado");
                    this.cierraModal();
                
                }else if(res.status == 204){ 
                    this.$toast.error('Tipo activo ya existe.') 
                }
            })
            .catch((error) => error) 
        },*/
        cierraModalDelet(){
            this.delTipoActivo = false 
        },
        eliminaRegistro(){
            this.idTipoActivo = this.form.id 
            this.delTipoActivo = true 
        },
        confirmInactivate(){
            // console.log(this.idTipoActivo); 
            TipoActivo.deleteTipoActivo(this.idTipoActivo) 
            .then((res) => { 
                if(res.status == 200){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("eliminado");
                    this.cierraModalDelet();
                    this.cierraModal();                
                }
            })
            .catch((error) => error) 
        },
        addCaracteristica(){
            this.nuevasCaracteristicas.push({
                codigo: "",
                descripcion: ""
            });
        },
        cleannInp(){
            this.nuevasCaracteristicas = [];
        }
    },
    watch:{
        infoEdit: {
            immediate: true,
            deep: true,
            handler(value) {
                if (value) {
                    this.form = { ...value };
                }
            }
        }
    },
}
</script>

<style>

</style>
